import Zone from "@insite/client-framework/Components/Zone";
import { MetaDescription, MetaKeywords } from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import MobiusPage from "@insite/mobius/Page";
import React from "react";

const enum fields {
    publishDate = "publishDate",
    author = "author",
    content = "content",
    thumbnail = "thumbnail",
    summary = "summary",

    displayPublishDate = "Publish date",
    displayAuthor = "Author",
    displayContent = "Blog content",
    displayThumbnail = "Thumbnail",
    displaySummary = "Summary",
}

interface OwnProps extends PageProps {
    fields: {
        [fields.publishDate]: string;
        [fields.author]: string;
        [fields.content]: string;
        [fields.thumbnail]: string;
        [fields.summary]: string;
    };
}

const BlogDetailPage = ({ id }: OwnProps) => {
    return (
        <MobiusPage>
            <Zone contentId={id as never} zoneName={"Content" as never} requireRows={true as never} />
        </MobiusPage>
    );
};
const pageModule: PageModule = {
    component: BlogDetailPage,
    definition: {
        displayName: "Blog Detail",
        pageType: "Content",
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        allowedParents: ["BlogCategoryPage"],
        allowedChildren: [],
        fieldDefinitions: [
            MetaKeywords,
            MetaDescription,
            {
                name: fields.publishDate,
                displayName: fields.displayPublishDate,
                editorTemplate: "DateTimeField",
                defaultValue: null,
                fieldType: "General",
            },
            {
                name: fields.author,
                displayName: fields.displayAuthor,
                editorTemplate: "SystemListDropDownField",
                systemListName: "Authors",
                defaultValue: "",
                fieldType: "General",
            },
            {
                name: fields.content,
                displayName: fields.displayContent,
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "Translatable",
                isRequired: true,
                collapsedToolbarButtons: {
                    moreText: {
                        buttons: ["paragraphFormat", "bold", "italic", "html"],
                        buttonsVisible: 4,
                    },
                },
                extendedConfig: {
                    imageEditButtons: ["imageDisplay", "imageAlign", "imageRemove"],
                },
            },
            {
                name: fields.thumbnail,
                displayName: fields.displayThumbnail,
                defaultValue: "",
                editorTemplate: "ImagePickerField",
                fieldType: "General",
            },
            {
                name: fields.summary,
                displayName: fields.displaySummary,
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "Translatable",
            },
        ],
    },
};

export default pageModule;
